// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';

import * as Formatters from '../ui/Formatters';
import * as MessageFormat from './MessageFormat';
import * as PortalApi from '../PortalApi';
import LinkedText from '../ui/LinkedText';
import * as ServiceIcons from './Icons';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchieveIcon from '@material-ui/icons/Unarchive';
import PlayIcon from '@material-ui/icons/PlayCircleFilled';
import PauseIcon from '@material-ui/icons/PauseCircleFilled';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

const styles = theme => ({
  ...MessageFormat.styles(theme),
});


/*
 * Format for an SMS
 */
class VoicemailFormat extends Component {

  state = {
    duration: 0,
    currentTime: 0,
    progress: 0,
    durationInterval: null,
    audioPlaying: false
  }

  formatDuration = (durationInSeconds) => {
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  }

  formatTime = (duration, round) => {
    if(round){
      duration = Math.round(duration / 30) * 30;
    }
    if(duration < 60){
      // return '00:00:' + duration < 10 ? '0' + duration : duration;
      return `00:00:${duration < 10 ? '0' + String(duration) : String(duration)}`
    } else if(duration < 60*60) {
      let min = parseInt(duration/60);
      let sec = parseInt(duration - (min*60));
      return `00:${min < 10 ? '0' + String(min): String(min)}:${sec < 10 ? '0' + String(sec): String(sec)}`
    } else {
      let hour = parseInt(duration/(60*60));
      let min = parseInt((duration - (hour*60*60))/60);
      let sec = parseInt(duration - (min*60) - (hour*60*60));
      return `${hour < 10 ? '0' + String(hour): String(hour)}:${min < 10 ? '0' + String(min): String(min)}:${sec < 10 ? '0' + String(sec): String(sec)}`
    }
  }

  getDuration = (event) => {
      if(event === 'started'){
          this.setState({audioPlaying: true});
          this.setState({ durationInterval: setInterval(() => {
              console.log("COming here", document.getElementById('audio')?.currentTime, this.state.duration);
              this.setState({progress: (document.getElementById('audio')?.currentTime/this.state.duration)*100})
          }, 100)})
      } else if(event === 'ended'){
          this.setState({audioPlaying: false, progress: 0});
          clearInterval(this.state.durationInterval);
      } else {
          this.setState({audioPlaying: false})
          clearInterval(this.state.durationInterval);
      }
  }

  handleSeek = (event, newValue) => {
    const audioElement = document.getElementById('audio');
    const calculatedValue = (newValue/100) * this.state.duration;
    audioElement.currentTime = calculatedValue;
    this.setState({ progress: newValue });
  };

  render() {
    /* eslint-disable */
    const { classes, message, toggleFollowup, archiveMessage, 
      unarchiveMessage, markMessageRead, unmarkMessageRead,
      setActivityDetailOpen, newContact, downloadVoiceMail } = this.props;

    let sender='Voicemail from ' + MessageFormat.messageDetail(message);
    
    return (
      <div className={classes.formatTop}>
        <div className={classes.messageSender}>
          <LinkedText value={sender} onClick={this.props.openContactLink}/>
        </div>
        <div className={classes.taken}>
          {Formatters.formatDateTime(message.taken)}
        </div>
        {/* <div className={classes.taken}>
          Reference ID: {message.messageId}
        </div>
        <div className={classes.taken}>
          Contact Description: {message.contactDescription}
        </div> */}

          <MuiCore.Grid item>
            <MuiCore.Grid container style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10}}>
            <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: message.dnis && 'pointer'}} onClick={() => {
                if(message.ani){
                  newContact(message.ani)
                }
              }}>
                 <MuiCore.Grid item style={{height: 50, width: 50, marginLeft: 10}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <ServiceIcons.SaveContactIcon fontSize='medium' style={{marginTop: 13, color:'#122457'}}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Save contact
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                if(message.read){
                  unmarkMessageRead(message.messageId)
                }else{
                  markMessageRead(message.messageId)
                }
                setActivityDetailOpen(false);
              }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50, marginLeft: 10}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <MuiCore.SvgIcon xmlns="http://www.w3.org/2000/svg" width="31.5" height="21" viewBox="0 0 31.5 21" style={{color: '#122457', marginTop: 13}}>
                      <path d="M.6.99V16.571L11.439,9.345ZM16.294,13.3l-3.726-2.823L.6,18.49V21.2H32.1V18.49L19.907,10.361Zm15.694,3.387V1.1L21.149,9.458ZM16.294,11.265,30.52.2H2.068Z" transform="translate(-0.6 -0.2)"/>
                    </MuiCore.SvgIcon>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  {message.read ? 'Mark unread' : 'Mark read'}
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                if(message.archived){
                  unarchiveMessage(message.messageId);
                }else {
                  archiveMessage(message.messageId);
                }
                setActivityDetailOpen(false);
                }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    {message.archived ? <UnarchieveIcon fontSize='medium' style={{marginTop: 13, color:'#122457'}}/> : <ArchiveIcon color='#122457' fontSize='medium' style={{marginTop: 13, color:'#122457'}}/>}
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                {message.archived ? 'Unarchive': 'Archive'}
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  this.props.openAssist(message);
                }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <ServiceIcons.AssistIcon fontSize='medium' style={{marginTop: 13}}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Assist
                </MuiCore.Typography>
              </MuiCore.Grid>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                toggleFollowup(message, true)
                }}>
                <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                  <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                    <ServiceIcons.FollowupIcon style={{color: '#122457', marginTop: 13}} followup={message.followup}/>
                  </MuiCore.Grid>
                </MuiCore.Grid>
                <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  Follow Up
                </MuiCore.Typography>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
        
        <MuiCore.Divider style={{marginTop: 20, marginBottom: 10}}/>

        <div className={classes.sectionHeader}>
          Call Details
        </div>
        
        <div style={{paddingTop: 10,display:'flex'}}>
          <MuiCore.Grid style={{display: 'flex', flexDirection: 'row', marginTop: 20}}>
                {this.state.audioPlaying ? <PauseIcon style={{color: '#B61256', cursor: 'pointer'}} fontSize='large' onClick={() => {
                    document.getElementById('audio').pause()
                }}/> : <PlayIcon style={{color: '#B61256', cursor: 'pointer'}} fontSize='large' onClick={() => {
                    document.getElementById('audio').play()
                }}/>}
                <MuiCore.Slider onChangeCommitted={this.handleSeek} value={this.state.progress} style={{width: message.recordingDuration !== undefined ? 400 : 430, margin: 5, marginLeft: 10 }}/>
                <MuiCore.Typography className={classes.minutesPlayed}>{this.formatDuration(message.recordingDuration)}</MuiCore.Typography>
                <div onClick={() => {
                  downloadVoiceMail(message.audioKey);
                }}>
                  <CloudDownloadIcon style={{marginTop: 5, color: '#B61256', cursor: 'pointer'}}/>
                </div>
            </MuiCore.Grid>
            <MuiCore.Grid>
                <audio style={{width: 500}} onLoadedMetadata={(event) => {
                    this.setState({ duration: message.recordingDuration })
                }} onEnded={(event) => {
                    this.getDuration('ended');
                }} onPlay={() => {
                    this.getDuration('started');
                }} onPause={() => {
                    this.getDuration('paused');
                }} src={PortalApi.BaseUrl() + '/api/media/voicemail/' + message.audioKey} id='audio' hidden={true} controls/>
            </MuiCore.Grid>
          {/* <audio controls style={{outline: 'unset'}}
                 src={PortalApi.BaseUrl() + '/api/media/voicemail/' + message.audioKey}/> */}
        </div>
        

        <MuiCore.Hidden xlDown={!Boolean(message.recordingTranscription)}>
          <div className={classes.sectionHeader}>
            Transcription
          </div>
          <MuiCore.Divider/>
          
          <div className={classes.fieldData}>
            <LinkedText value={message.recordingTranscription} onClick={this.props.openContactLink}/>            
          </div>
        </MuiCore.Hidden>

        <MuiCore.Grid style={{marginTop: 20}}>
        <MuiCore.Grid item>
            <div className={classes.fieldData}>
              Call From: <LinkedText value={ MessageFormat.messageDetail(message)} onClick={this.props.openContactLink}/>
            </div>
            {/* <div className={classes.fieldData}>
              <LinkedText value={Formatters.formatPhoneNumber(message.ani)} onClick={this.props.openContactLink}/>
            </div> */}
          </MuiCore.Grid>
          <MuiCore.Grid item>
            <div className={classes.fieldData}>
              Call To: <LinkedText value={Formatters.formatPhoneNumber(message.dnis)} onClick={this.props.openContactLink}/>
            </div>
            {/* <div className={classes.fieldData}>
              <LinkedText value={Formatters.formatPhoneNumber(message.dnis)} onClick={this.props.openContactLink}/>
            </div> */}
          </MuiCore.Grid>
          
          <MuiCore.Grid item xs={12} sm={4}>
            <div className={classes.fieldData}>
              Call From Location: {message.fromCity}, {message.fromState} {message.fromCountry}
            </div>
            {/* <div className={classes.fieldData}>
              {message.fromCity}, {message.fromState} {message.fromCountry}
            </div> */}
          </MuiCore.Grid>
        </MuiCore.Grid>

        <MuiCore.Grid item>
            <div className={classes.sectionHeader} style={{marginTop: 20}}>
              Duration
            </div>
            <div style={{fontFamily: 'Sofia'}}>
                Receptionist Time: {message.billableAgentMinutes !== undefined ? this.formatTime(message.billableAgentMinutes * 60) : '00:00:00'}
            </div>
            <div style={{fontFamily: 'Sofia'}}>
              Call Length: {message.callLengthInSeconds !== undefined ? this.formatTime(message.callLengthInSeconds, true) : '00:00:00'}
            </div>
        </MuiCore.Grid>

        <MessageFormat.MessageStatus
          message={message}
          sectionHeaderClass={classes.sectionHeader}
          fieldLabelClass={classes.fieldLabel}
          fieldDataClass={classes.fieldData}/>       
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    message : serviceSelectors.getMessage(state),
  });
};

const mapDispatchToProps = {
  openContactLink : serviceActions.openContactLink,
  toggleFollowup: serviceActions.toggleFollowup,
  openAssist : serviceActions.openAssist,
  archiveMessage : serviceActions.archiveMessage,
  unarchiveMessage : serviceActions.unarchiveMessage,
  markMessageRead : serviceActions.markMessageRead,
  unmarkMessageRead : serviceActions.unmarkMessageRead,
  setActivityDetailOpen : serviceActions.setActivityDetailOpen,
  newContact : serviceActions.newContact,
  downloadVoiceMail: serviceActions.downloadVoiceMail,
};

export default connect(mapStateToProps,
                       mapDispatchToProps)(withStyles(styles)(VoicemailFormat));

